import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Person } from '@gravity-ui/icons';
import { useViewerStore } from '@stores/viewerStore';
import { useAuthStore } from '@stores/authStore';
import { useShareAction } from '@hooks/useShareAction';
import { IcShare } from './HudIcons';
import { Avatar, Button, ButtonGroup } from '@heroui/react';
import { Pill } from './PillPrimitives';
import { authAdapter } from '@services/auth';
import { UserInfoPopover } from './UserPill';

export function SceneInfoMobile() {
  const { t } = useTranslation();
  const sharePanelOpen = useViewerStore((s) => s.sharePanelOpen);
  const user = useAuthStore((s) => s.user);
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const [userInfoOpen, setUserInfoOpen] = useState(false);
  const handleShare = useShareAction();

  return (
    <>
      <Pill horizontal className="gap-1 px-1">
        <ButtonGroup className="gap-0" variant="secondary" size="md">
          <Button
            isIconOnly
            aria-label={sharePanelOpen ? t('share.close-share') : t('share.share')}
            onPress={handleShare}
            className="rounded-full"
          >
            <IcShare className="size-4" />
          </Button>
        </ButtonGroup>

        {/* 用户头像 */}
        <Button
          isIconOnly
          size="md"
          variant="secondary"
          className="rounded-full"
          aria-label="User"
          onPress={() => {
            if (!isLoggedIn) {
              void authAdapter.login();
              return;
            }
            setUserInfoOpen(true);
          }}
        >
          <Avatar className="h-6 w-6 rounded-full">
            {user?.avatar ? (
              <Avatar.Image alt={user.name} src={user.avatar} />
            ) : (
              <Avatar.Fallback className="bg-default-200 flex h-full w-full items-center justify-center">
                <Person width={14} height={14} className="text-default-500" />
              </Avatar.Fallback>
            )}
          </Avatar>
        </Button>
      </Pill>

      {userInfoOpen && (
        <UserInfoPopover
          onClose={() => setUserInfoOpen(false)}
          panelClassName="absolute top-14 right-0 z-50 w-60 max-w-[calc(100vw-2.5rem)] rounded-2xl bg-white/10 p-5 shadow-xl backdrop-blur-md"
        />
      )}
    </>
  );
}
